<template>
    <section>
        <page-header>
            <slot slot="title">{{ $t('customer.checkout.confirmation_title') }}</slot>
            <slot slot="description">
              {{ $t('customer.account.backorders.order_number.label') }}: <strong>{{ orderNumber }}</strong>
            </slot>
        </page-header>
        <div class="c-basket-state o-page-row--large u-text-align-center">
            <span class="item"><span>{{ $t('customer.checkout.basket') }}</span></span>
            <span class="item"><span>{{ $t('customer.checkout.data') }}</span></span>
            <span class="item active"><span>{{ $t('customer.checkout.confirmation') }}</span></span>
        </div>
        <div class="o-wrapper o-wrapper--center">
          <router-link :to="{ name:'CustomerAccountHistory' }">{{ $t('customer.checkout.customer_account_history') }}</router-link>
        </div>
    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VInput
        },
        computed:{
            ...mapGetters({
                orderNumber: 'getOrderAxId',
                gtmObject: 'getGTMObject'
            })
        },
        created() {
            //add Google Tag Manager script to <head> in production environment
            if(process.env.NODE_ENV !== 'production') return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(this.gtmObject);

            window.triggerGTM(window, document, 'script', 'dataLayer', 'GTM-PB6XD25');
        },
        beforeDestroy() {

            //remove Google Tag Manager script from <head> in production environment
            if(process.env.NODE_ENV !== 'production') return;

            var headTag = document.getElementsByTagName('head')[0];
            headTag.removeChild(headTag.firstChild);
        },
        methods:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/views/customer/basket/Confirmation.vue